import axios from "axios";
import {
  STUDENT_SIGNUP_FAILURE,
  STUDENT_SIGNUP_SUCCESS,
} from "../Redux/AuthReducer/actionTypes";
import * as types from "../Redux/BookmarkReducer/actionTypes"

export const registerUser = (userData, dispatch) => {
  return axios
    .post("http://54.206.125.24:8888/api/v1/auth/register/user", userData)
    .then((r) => {
      console.log(r);
      dispatch({
        type: STUDENT_SIGNUP_SUCCESS,
        payload: r.data,
      });
      return STUDENT_SIGNUP_SUCCESS;
    })
    .catch((err) => {
      dispatch({
        type: STUDENT_SIGNUP_FAILURE,
        payload: true,
      });
    });
};

export const convertTimeFormat = (scheduledTime) => {
  const [date, time] = scheduledTime.split(" ");
  const [hours, minutes, seconds] = time.split(":");
  const amPm = hours > 12 ? "PM" : "AM";
  const hou = hours % 12 || 12;
  const fullFormat =
    hou < 10 ? `0${hou}:${minutes} ${amPm}` : `${hou}:${minutes} ${amPm}`;
  return fullFormat;
};

export const convertDate = (scheduledTime) => {
  const months = {
    1: "JAN",
    2: "FEB",
    3: "MAR",
    4: "APR",
    5: "MAY",
    6: "JUN",
    7: "JUL",
    8: "AUG",
    9: "SEP",
    10: "ACT",
    11: "NOV",
    10: "DEC",
  };
  console.log("index.js", scheduledTime);
  const [fullDate, time] = scheduledTime.split(" ");
  const [year, month, date] = fullDate.split("/");
  const latterMonth = months[Number(month)];
  const lastTwoDigitOfYear = year[year.length - 2] + "" + year[year.length - 1];
  const finalDate = `${date} ${latterMonth},${lastTwoDigitOfYear}`;
  return finalDate;
};

export const getBookmarks = (userId, token) => (dispatch) => {
  console.log(userId, token);
  dispatch({ type: types.GET_BOOKMARK_REQUEST });
  return axios
    .get(`http://54.206.125.24:8888/bookmark/MyBookmarks/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((r) => {
      console.log("bookmarksapi", r.data);
      dispatch({ type: types.GET_BOOKMARK_SUCCESS, payload: r.data });
    })
    .catch((err) => {
      console.log("getBooksmarks err", err);
      dispatch({ type: types.SET_BOOKMARK_FAILURE, payload: err });
    });
};

export const setBookMark = (userId, lectureId, token) => (dispatch) => {
  console.log("sdsdf", userId, lectureId, token);
  dispatch({ type: types.SET_BOOKMARK_REQUEST });
  return axios({
    method: "post",
    url: `bookmark/?userId=${userId}&lectureId=${lectureId}`,
    baseURL: "http://54.206.125.24:8888/",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((r) => {
      console.log("setBookdata", r.data);
      dispatch({ type: types.SET_BOOKMARK_SUCCESS, payload: r.data });
      getBookmarks(userId,token)
      return types.SET_BOOKMARK_SUCCESS;
    })
    .catch((err) => {
      console.log("err setbookmark", err);
      dispatch({ type: types.SET_BOOKMARK_FAILURE, payload: err });
    });
};

export const deleteBookMark = (userId, lectureId, token) => (dispatch) => {
  dispatch({ type: types.REMOVE_BOOKMARK_REQUEST });
  return axios({
    method: "delete",
    url: `bookmark/${userId}/${lectureId}`,
    baseURL: "http://54.206.125.24:8888/",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((r) => {
      dispatch({ type: types.REMOVE_BOOKMARK_SUCCESS, payload: r.data });
      getBookmarks(userId,token)
      return types.REMOVE_BOOKMARK_SUCCESS;
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: types.REMOVE_BOOKMARK_FAILURE, payload: err });
    });
};

